import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, Tooltip, OverlayTrigger } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { Field, reduxForm, reset } from "redux-form";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  fetchQAReply,
  replyToLiveQA,
  fetchLiveQA,
  fetchUnpublishedLiveQA,
} from "LiveQAAction";
import { COMMON_FAIL_MESSAGE } from "Constants";
import LocaleStrings from "Languages";

class QAReply extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      replies: {},
      loading: false,
      replyLoading: false,
      count: 0,
      refresh: false,
    };
  }

  componentDidMount() {}

  openModal = () => {
    let { qaReply } = this.props;

    this.setState({ showModal: true, replyLoading: true });
    this.props.fetchQAReply(this.props.session, qaReply, (response) => {
      if (response.success) {
        this.setState({ replyLoading: false });
      }
    });
  };

  closeModal = () => {
    this.props.reset();
    this.setState({ showModal: false });
  };

  changeStatus = () => {
    this.props.changePub();
  };

  important = () => {
    this.props.important();
  };

  onSubmitForm = (data) => {
    let {
      qaReply,
      session,
      selectPublishedType,
      selectedSession,
      currentPage,
    } = this.props;

    var values = {
      ...data,
      qaid: qaReply.qaid,
      eventid: qaReply.eventid,
      replyby: session.userid,
    };

    this.setState({ loading: true });
    this.props.replyToLiveQA(session, qaReply, values, (response) => {
      if (response.success === 0) {
        this.setState({ loading: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        this.setState({ loading: false });
        this.props.reset();

        if (
          selectPublishedType &&
          selectPublishedType.ispublished == "published"
        )
          this.props.fetchLiveQA(session, selectedSession, currentPage);
        else {
          this.props.fetchUnpublishedLiveQA(
            session,
            selectedSession,
            currentPage
          );
        }
      }
    });
  };

  refreshLiveQAReplies = () => {
    let { qaReply, session } = this.props;

    this.setState({ refresh: true });
    this.props.fetchQAReply(session, qaReply, (response) => {
      this.setState({ refresh: false });
      if (response.success) {
      }
    });
  };

  // renderFieldText = (field) => {
  //     var formdiv = '';
  //     if(field.formdiv !== undefined && field.formdiv === 'false'){
  //        formdiv = '';
  //     }
  //     var divClassName=`col-md-12 ${formdiv} ${(field.meta.touched && field.meta.error)?'has-danger':''}`;
  //     divClassName = `${divClassName} ${field.bsClass?field.bsClass:''}`;

  //     return(
  //         <div className={divClassName}>
  //           <input
  //             className="form-control"
  //             type={field.type}
  //             placeholder={field.placeholder}
  //             {...field.input}
  //           />
  //           <div className="text-help label-text-help" style={{textAlign:'left'}}>{field.meta.touched?field.meta.error:''}</div>
  //       </div>
  //     );
  // }

  renderFieldTextarea = (field) => {
    var divClassName = `col-sm-12 ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName}`;
    return (
      <div className={divClassName}>
        <textarea
          className="form-control"
          placeholder={field.placeholder}
          maxLength={field.maxLength}
          {...field.input}
          onChange={(e) => {
            field.onTextChangeCallback(e);
            field.input.onChange(e);
          }}
        ></textarea>
        <div
          className="text-help label-text-help"
          style={{ textAlign: "left" }}
        >
          {field.meta.touched ? field.meta.error : ""}
        </div>
      </div>
    );
  };

  onTextChange = (event) => {
    var content = event.target.value.trimLeft();
    var count = content.length;

    if (count <= 235) {
      this.setState({ count: event.target.value.length });
    } else {
      this.setState({ count: 235 });
      const { touch } = this.props;
      touch("reply");
    }
  };

  render() {
    let {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      qaReply,
      liveQAReplies,
    } = this.props;
    let checked = false;
    if (qaReply.ispublished) {
      checked = true;
    }

    var iconURL = `../../style/images/poll-icons/grey_star.png`;
    if (qaReply.isimportant) {
      iconURL = `../../style/images/poll-icons/golden_star.png`;
    }

    let replies = [];
    if (
      liveQAReplies &&
      liveQAReplies.resource &&
      liveQAReplies.resource.resource
    ) {
      liveQAReplies.resource.resource.map((item, index) => {
        replies.push(
          <div className="scrollButtom" key={`reply_${index}`}>
            <div key={`${index}`}>
              <p>{item.reply}</p>
              <p>
                ~{" "}
                {item.replyby ? item.appuser_by_replyby.username : "Anonymous"}
              </p>
              <hr className="hr-custom-new" />
            </div>
          </div>
        );
      });
    }

    var charLeft = 235 - this.state.count;
    var charLeftString = `${charLeft} character(s) left`;
    var message = charLeft >= 0 ? <span>{charLeftString}</span> : null;

    return (
      <div>
        <div>
          <button
            className="btn-custom-table-white"
            type="button"
            onClick={this.openModal}
          >
            {LocaleStrings.reply} ( {qaReply.totalcomments} )
          </button>
        </div>
        <div>
          <Modal
            className="modal-container"
            show={this.state.showModal === true ? true : false}
            animation={true}
          >
            <Modal.Header style={{ height: 70 }}>
              <div className="">
                <div className="import-modal-title" style={{ display: "flex" }}>
                  <div style={{ marginRight: 20 }}>
                    {LocaleStrings.polls_qa_text_reply_to}{" "}
                    <span style={{ color: "#4da1ff" }}>
                      {qaReply && qaReply.appuser_by_questionedby
                        ? qaReply.appuser_by_questionedby.username
                        : "Anonymous"}
                    </span>
                  </div>

                  <div style={{ width: "5%", marginRight: 10 }}>
                    <img
                      onClick={this.important}
                      src={iconURL}
                      style={{ width: "83%" }}
                    />
                  </div>

                  <label className="poll-switch">
                    <input
                      type="checkbox"
                      onChange={this.changeStatus}
                      checked={checked}
                    />
                    <span className="poll-slider poll-round"></span>
                  </label>

                  <OverlayTrigger
                    key="refresh"
                    placement="top"
                    overlay={
                      <Tooltip id="tooltip-manage">
                        {LocaleStrings.polls_qa_text_refresh_live_qa_replies}
                      </Tooltip>
                    }
                  >
                    <a
                      className="btn btn-default"
                      onClick={this.refreshLiveQAReplies}
                      style={{ marginLeft: 10 }}
                    >
                      {" "}
                      {this.state.refresh ? (
                        <i
                          className="fa fa-refresh fa-spin"
                          aria-hidden="true"
                        ></i>
                      ) : (
                        <i className="fa fa-refresh" aria-hidden="true"></i>
                      )}{" "}
                    </a>
                  </OverlayTrigger>
                  <button
                    type="button"
                    className="i-custom-cross-popup pull-right"
                    onClick={() => this.closeModal()}
                    style={{ marginLeft: "auto" }}
                  >
                    <img
                      className="i-custom-small"
                      src="../../style/images/custom-icons/cross-black.png"
                    />
                  </button>
                </div>

                {/* <button
                  type="button"
                  className="close btn-sm btn-close "
                  onClick={() => this.closeModal()}
                  style={{ marginTop: -40 }}
                >
                  <span aria-hidden="true">&times;</span>
                </button> */}
                {/* <button
                  type="button"
                  className="i-custom-cross-popup pull-right"
                  onClick={() => this.closeModal()}
                  // style={{textAlign:'end'}}
                >
                  <img
                    className="i-custom-small"
                    src="../../style/images/custom-icons/cross-black.png"
                  />
                </button> */}
              </div>
            </Modal.Header>
            <Modal.Body>
              <p>{qaReply.question}</p>
              <hr className="hr-custom-new" />
              <div className="liveqa-replies-body">
                {this.state.replyLoading ? "" : replies}
              </div>
            </Modal.Body>

            <Modal.Footer style={{ height: 190, justifyContent: "start" }}>
              <form
                onSubmit={handleSubmit(this.onSubmitForm)}
                encType="multipart/form-data"
              >
                <div
                  className="basicform vertical-align-center"
                  style={{ width: "380px" }}
                >
                  {/* <Field
                    name="reply"
                    placeholder="Reply to the question"
                    type="text"
                    component={this.renderFieldText}
                    mandatory="true"
                  /> */}

                  <Field
                    name="reply"
                    placeholder={
                      LocaleStrings.polls_qa_reply_form_label_reply_placeholder
                    }
                    component={this.renderFieldTextarea}
                    onTextChangeCallback={this.onTextChange}
                    maxLength={235}
                  />
                  <Button
                    className="btn-custom-blue"
                    // loading={this.state.loading}
                    disabled={this.state.loading}
                    type="submit"
                    style={{ marginLeft: "10px" }}
                  >
                    {LocaleStrings.button_send}
                  </Button>
                </div>
                <p
                  style={{ textAlign: "left", paddingLeft: 15, paddingTop: 5 }}
                >
                  {message}
                </p>
              </form>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    liveQAReplies: state.liveQAReplies,
    selectPublishedType: state.selectPublishedType,
    selectedSession: state.selectedSession.resource,
  };
}

function validate(values) {
  var errors = {};
  var reply = values["reply"];

  if (reply && reply.trim() === "") {
    errors["reply"] = LocaleStrings.polls_qa_reply_validation_blank_space;
  }
  return errors;
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  fetchQAReply,
  replyToLiveQA,
  fetchLiveQA,
  fetchUnpublishedLiveQA,
})(
  reduxForm({
    validate,
    form: "liveQAReplyForm",
  })(QAReply)
);
